
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18.5 8C19.33 8 20 7.33 20 6.5C20 5.67 19.33 5 18.5 5H6.38998L9.38998 8H11.22L10.67 9.28L12.76 11.37L14.21 8H18.5ZM17.44 18.88L4.11998 5.56C3.72998 5.17 3.09998 5.17 2.70998 5.56C2.31998 5.95 2.31998 6.58 2.70998 6.97L8.96998 13.23L7.31998 17.07C6.92998 17.99 7.59998 19 8.58998 19C9.13998 19 9.63998 18.67 9.85998 18.16L11.07 15.33L16.02 20.28C16.41 20.67 17.04 20.67 17.43 20.28C17.83 19.9 17.83 19.27 17.44 18.88Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-format-clear`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFormatClear

    ```js
    <b-new-b-icon-format-clear />
    ```
</docs>


